import React, { useState } from 'react'

import { ResetAuthPartKind, useResetAuthPart } from '@dentalux/security'

import { useUnauthorizedDispatch, setEmail } from 'src/components/providers/UnauthorizedProvider'
import ForgotPasswordScreen from 'src/screens/ForgotPassword'
import withTranslation from 'src/staticProps/withTranslation'

const ForgotPasswordPage = () => {
  const [isSuccess, setIsSuccess] = useState<boolean>(false)
  const dispatch = useUnauthorizedDispatch()

  const { reset, isLoading, error } = useResetAuthPart({
    kind: ResetAuthPartKind.PASSWORD,
    onSuccess: () => setIsSuccess(true),
    onError: () => dispatch(setEmail('')),
  })

  const handleResendLink = () => {
    setIsSuccess(false)
  }

  return (
    <ForgotPasswordScreen
      onSubmit={reset}
      onResendLink={handleResendLink}
      processing={isLoading}
      error={error}
      success={isSuccess}
    />
  )
}

export const getStaticProps = withTranslation

export default ForgotPasswordPage
